import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { ReactComponent as CalendarIcon } from 'assets/icons/Calendar.svg';

import { IGanttChartMobileRow as IProps } from './types';

import styles from './GanttChartMobileRow.module.scss';

export const GanttChartMobileRow: FC<IProps> = ({ stage, from, to }) => (
  <Box>
    <Typography className={styles.title} variant="h5">
      {stage}
    </Typography>
    <Typography className={styles.text} variant="body1">
      <CalendarIcon className={styles.icon} />
      {from} - {to}
    </Typography>
  </Box>
);
